import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

/**
 * Navigation hors de l'application (page OAuth de Google ou d'Apple…) :
 * la page entière est remplacée, le routeur Angular n'intervient pas.
 *
 * Passer par ce service plutôt que par `window.location.href` garde le
 * comportement identique en production tout en rendant la redirection
 * observable dans les tests (on y remplace simplement le service).
 */
@Injectable({ providedIn: 'root' })
export class ExternalNavigationService {
  private readonly document = inject(DOCUMENT);

  redirectTo(url: string): void {
    this.document.location.href = url;
  }
}
